module.exports = __webpack_public_path__ + "static/media/rhugaved_narmade.97e0f995.jpeg";